/**
 * Copyright 2019, OpenCensus Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RootSpan } from './root-span';
import { TracerBase } from './tracer-base';
/** Tracer manages the current root span and trace header propagation. */
var Tracer = /** @class */ (function (_super) {
    __extends(Tracer, _super);
    function Tracer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Get and set the currentRootSpan of the tracer. */
        _this.currentRootSpan = new RootSpan(_this);
        return _this;
    }
    /**
     * Start a new RootSpan to currentRootSpan. Currently opencensus-web only
     * supports a single root span at a time, so this just sets `currentRootSpan`
     * to a new root span based on the given options and invokes the passed
     * function. Currently no sampling decisions are propagated or made here.
     * @param options Options for tracer instance
     * @param fn Callback function
     * @returns The callback return
     */
    Tracer.prototype.startRootSpan = function (options, fn) {
        var _this = this;
        return _super.prototype.startRootSpan.call(this, options, function (root) {
            _this.currentRootSpan = root;
            return fn(root);
        });
    };
    /** Clears the current root span. */
    Tracer.prototype.clearCurrentTrace = function () {
        this.currentRootSpan = new RootSpan(this);
    };
    /**
     * Start a new Span instance to the currentRootSpan
     * @param name Span name or SpanOptions object.
     * @param kind Span kind
     * @returns The new Span instance started
     */
    Tracer.prototype.startChildSpan = function (options) {
        return _super.prototype.startChildSpan.call(this, Object.assign({ childOf: this.currentRootSpan }, options));
    };
    /**
     * Binds the trace context to the given function - but because opencensus-web
     * currently only supports a single trace context at a time, this just returns
     * the function.
     */
    Tracer.prototype.wrap = function (fn) {
        return fn;
    };
    /** Binds trace context to NodeJS event emitter. No-op for opencensus-web. */
    Tracer.prototype.wrapEmitter = function (emitter) { };
    return Tracer;
}(TracerBase));
export { Tracer };
//# sourceMappingURL=tracer.js.map